module.exports = __webpack_public_path__ + "static/media/fa-solid-900.dd5e5b90.ttf";